import axios from "@/axios/tokenInterceptor";
import { defineStore } from "pinia";
import { useAPIStore, useUtilsStore } from "@/store";
import router from "@/router";
import { ReturnAsset_ReasonArray } from "@/assets/js/dropdown";
import _ from "lodash";
// 資產交還 通用function
export const useReturnAssetStore = defineStore("ReturnAsset", {
  // data
  state: () => ({
    // edit or view
    PageType: "",
    // 下拉選單
    DropdownArray: {
      Staff: [],
      Reason: ReturnAsset_ReasonArray,
      Area: [],
      Layer: [],
    },
    // 表單
    Form: {
      RR_ID: "", // 單號
      ReturnDate: "", // 接收(申請)日期
      ReturnPersonName: "", // 接收(申請)人員(Text)
      ReturnPerson: "", // 接收(申請)人員(Value)
      Custodian: "", // 交還人員(Value)
      CustodianName: "", // 交還人員(Text)
      Reason: "", // 交還原因
      Memo: "", // 備註
      TotalNum: "", // 交還清冊總筆數
      AssetList: [],
      // 交還文件
      newDocument: [],
      viewDocument: [], //不需要傳
      existDocument: [], //不需要傳
      deleteDocument: [],
    },
  }),
  // computed
  getters: {},
  // method
  actions: {
    /**
     * 交還單的新增/編輯
     * @param {String} type 'new' || 'edit'
     * @param {String} dgModel {dgRowData: datagrid資料, selectedList: 勾選的資料}
     * @returns
     */
    async submit(type, dgModel) {
      const utilsStore = useUtilsStore();
      // 檢查必填
      if(!utilsStore.checkRequired(this.Form, ['Custodian', 'Reason'])) return
      // check AssetList Status
      let validStatus = ['借測', '內部領用', '在庫'];
      if (dgModel.dgRowData.some(item => !validStatus.includes(item.Status))) {
        alert('資產點交清冊內若有維修、出貨、報廢、退貨、無庫存之資產，請前往資產管理移轉保管人員。若有設備整合箱之資產，請前往設備整合管理移轉整合箱保管人員。');
        return;
      }
      try {
        // reset AssetList
        this.Form.AssetList = [];
        dgModel.dgRowData.forEach((item)=>{
          this.Form.AssetList.push({
            AssetsId: item.AssetsId,
            IsReturn: dgModel.selectedList.includes(item)
          })
        })
        const RR_ID = await this.sendTextForm(type);
        // send Files
        const filePromises = [];
        for (let i = 0; i < this.Form.newDocument.length; i++) {
          filePromises.push(this.sendFiles(RR_ID, this.Form.newDocument[i], i));
        }
        await Promise.all(filePromises)
        .then(result => {
          const allSuccess = result.every(result => result === 'success')
          const prefix = type === 'new' ? '新增' : '編輯'
          if(allSuccess) {
            alert(`${prefix}資產交還單成功\n單號: ${RR_ID}`);
            router.push({name: 'Return_Asset_Datagrid'});
          } else {
            alert(`${prefix}資產交還單失敗`);
          }
        })
      } catch (error) {
        console.error(error);
        alert(error)
      }
    },
    /**
     * 取得交還單資料
     * @param {String} RR_ID 單號
     * @param {String[]} Conditions 可進入的單號狀態(可不給 -> 不限制)，不符合就跳轉
     */
    async getDetails(RR_ID, Conditions = []) {
      try {
        const response = await axios.get(`/ReturnAssetMng/AssetReturnInfo?RR_ID=${RR_ID}`);
        const data = response.data;
        if (data.state === "success") {
          if (Conditions.length > 0) {
            useUtilsStore().canEnterPage(data.resultList.Status, Conditions);
          }
          console.log("資料維修單資料", data.resultList);
          // 塞入表單資訊
          Object.keys(this.Form).forEach((key) => {
            if (data.resultList[key]) {
              this.Form[key] = data.resultList[key];
            }
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * 刪除交還單
     * @param {String} RR_ID 單號
     */
    async deleteData(RR_ID) {
      const form = new FormData();
      form.append("RR_ID", RR_ID);
      try {
        const response = await axios.post(
          `/ReturnAssetMng/DeleteAssetReturn`,
          form
        );
        const data = response.data;
        if (data.state === "success") {
          let msg = data.message + "\n單號:" + RR_ID;
          alert(msg);
          router.push({
            name: "Return_Asset_Datagrid",
          });
        } else if (data.state === "error") {
          alert(data.messages);
        }
      } catch (error) {
        console.error(error);
      }
    },
    
    async sendTextForm(type) {
      let url;
      switch (type) {
        case "edit":
          url = "/ReturnAssetMng/EditAssetReturn";
          break;
        case "new":
          url = "/ReturnAssetMng/CreateAssetReturn";
          break;
      }
      let requestData = {
        Custodian: this.Form.Custodian,
        Reason: this.Form.Reason,
        Memo: this.Form.Memo,
        AssetList: this.Form.AssetList,
      }
      if(type === 'edit') {
        requestData = {
          ...requestData,
          RR_ID: this.Form.RR_ID,
          deleteDocument: this.Form.deleteDocument,
        }
      }
      // console.log(requestData);
      // return
      try {
        const response = await axios.post(
          "" + url,
          requestData
        );
        const data = response.data;
        if (data.state === "success") {
          return Promise.resolve(data.resultList.RR_ID)
        } else {
          return Promise.reject(data.message);
        }
      } catch (e) {
        console.error(e);
        return Promise.reject(e);
      }
    },
    async sendFiles(RR_ID, file, index) {
      return new Promise((resolve, reject) => {
        const utilsStore = useUtilsStore();
        const form = new FormData();
        const requestData = {
          RR_ID: RR_ID,
          num: index,
          Document: file,
        }
        utilsStore.setFormData(requestData, form);
        axios.post(`/ReturnAssetMng/UploadDoc`, form)
        .then(res=>{
          const data = res.data;
          if(data.state === 'success') {
            console.log(`第${index + 1}個檔案上傳成功`);
            resolve(data.state);
          } else {
            console.error(`第${index + 1}個檔案上傳失敗`+ res.data.messages);
            reject(`第${index + 1}個檔案上傳失敗`+ res.data.messages)
          }
        })
        .catch(e=>{
          reject(e);
        })
      })
    },
    /**
     * 如有給 RR_ID 的話，可查詢有改變過的 IsReturn(比對資料單的交還人員是否與下拉選單的同一人)。
     * 是否切換資產狀態 為"入庫"時需要顯示入庫後的假狀態
     * 行數/頁數 為資料單的 TotalNum 過大時，避免 API長度過長。
     * @summary 取得交還人員的保管資產清單 Array
     * @param {String} user 交還人員
     * @param {String} RR_ID 資產交還單號
     * @param {Boolean} changeStatus 是否切換資產狀態
     * @param {String} rows 行數(可超過實際數量 -> 就等於全拿)
     * @param {String} page 頁數
     * @returns {Promise<[]>}
     */
    async getCustodianAssetList(user, RR_ID = null, changeStatus = false, rows = '10000', page = '1') {
      // return Promise.resolve([
      //   { AssetsId: 'BF12345678', IsReturn: true, AssetName: '物品一', InBoundDate: '2024-08-12', Area_Id: 'A0001', Layer_Id: '' },
      //   { AssetsId: 'BF12345688', IsReturn: false, AssetName: '物品二', InBoundDate: '2024-08-12', Area_Id: 'A0002', Layer_Id: '' },
      // ])
      const requestData = {
        Custodian: user,
        RR_ID,
        changeStatus,
        rows,
        page
      }
      try {
        const response = await axios.post(`/ReturnAssetMng/AssetReturnList`, requestData);
        const data = response.data;
        console.log(data);
        if(data.state === 'success') {
          return data.resultList
        } else {
          alert(data.messages);
          return []
        }
      } catch (error) {
        console.error(error);
        return []
      }
    },
  },
});
